export default __webpack_public_path__ + "static/media/food5.095b14cf.jpg";